import {
  AppBar,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
  styled,
  tooltipClasses,
} from "@mui/material";
import { AccountCircle } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  changePasswordFromProfile,
  deleteCustomerLogo,
  deleteCustomerUserLogo,
  getAllCountry,
  getChildCustomerByParentId,
  getCustomerLoginsById,
  getCustomerLogos,
  getCustomerUserLogos,
  getLoggedInCustomer,
  getLoggedInCustomerLogins,
  getLoggedInCustomerUser,
  logout,
  updateCustomerProfile,
  updateCustomerUserProfile,
  updateCustomerItinerary,
  updateCustomerUserItinerary,
} from "../../redux/actions/CustomerAction";
import "../../CSS/CustomerHeader.css";
import logo from "../../assets/gtechlogo.png";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import CloseIcon from "@mui/icons-material/Close";
import EmailIcon from "@mui/icons-material/Email";
import BusinessIcon from "@mui/icons-material/Business";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import MarkunreadMailboxIcon from "@mui/icons-material/MarkunreadMailbox";
import NotificationPopup from "../../Components/NotificationPopup";
import {
  CHANGE_PASSWORD_FROM_PROFILE_RESET,
  UPDATE_CUSTOMER_PROFILE_RESET,
  UPDATE_CUSTOMER_USER_PROFILE_RESET,
} from "../../Constants/Constants";
import FullPageLoader from "../../Components/FullPageLoader";
import PreviewIcon from "@mui/icons-material/Preview";
import ItinerarySettings from "../Customer/ItinerarySettings";

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

export default function CustomerHeader(props) {
  const { decodedToken } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [tabValue, setTabValue] = useState(0); // To track selected tab (Profile or Change Password)
  const [imageDialogOpen, setImageDialogOpen] = useState(false); // State for image dialog
  const [previewImage, setPreviewImage] = useState(null); // State to hold the image for preview
  const [previewDialogOpen, setPreviewDialogOpen] = useState(false); // State for preview dialog

  const [customer_name, setCustomer_name] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState([]);
  const [emailError, setEmailError] = useState([]);
  const [cc, setCC] = useState([]);
  const [ccError, setCCError] = useState("");
  const [contact_number, setContact_number] = useState("");
  const [contact_number_error, setContact_number_error] = useState("");
  const [PCCs, setPCCs] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [postal_code, setPostal_code] = useState("");
  const [postalCodeError, setPostalCodeError] = useState("");
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState("");
  const [language, setLanguage] = useState("");

  const [first_name, setFirst_name] = useState("");
  const [last_name, setLast_name] = useState("");
  const [cust_user_username, setCust_user_username] = useState("");
  const [cust_user_email, setCust_user_email] = useState("");
  const [cust_user_email_error, setCust_user_email_error] = useState("");
  const [cust_user_contact_number, setCust_user_contact_number] = useState("");
  const [cust_user_contact_number_error, setCust_user_contact_number_error] =
    useState("");
  const [cust_user_pcc, setCust_user_pcc] = useState("");
  const [logos, setLogos] = useState([]); // State to hold all uploaded logos
  const [logoError, setLogoError] = useState(""); // State for a single logo error
  const [additionalLogos, setAdditionalLogos] = useState([]); // State for additional logos
  const [additionalLogoError, setAdditionalLogoError] = useState(""); // State for additional logo error
  const [selectedHeaderLogo, setSelectedHeaderLogo] = useState([]); // State for selected header logos
  const [selectedFooterLogo, setSelectedFooterLogo] = useState([]); // State for selected footer logos
  const [selectedAdditionalHeaderLogo, setSelectedAdditionalHeaderLogo] =
    useState([]); // State for selected additional header logos
  const [selectedAdditionalFooterLogo, setSelectedAdditionalFooterLogo] =
    useState([]); // State for selected additional footer logos

  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertTitle, setErrorAlertTitle] = useState("");
  const [errorAlertMessage, setErrorAlertMessage] = useState("");

  const [notificationOpen, setNotificationOpen] = useState(false);
  const [openLoader, setOpenLoader] = useState(false);

  const [current_passoword, setCurrent_password] = useState("");
  const [new_password, setNew_password] = useState("");
  const [confirm_password, setConfirm_password] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const GetLoggedInCustomer = useSelector((state) => state.GetLoggedInCustomer);
  const { loggedInCustomerInfo } = GetLoggedInCustomer;

  const GetLoggedInCustomerLogins = useSelector(
    (state) => state.GetLoggedInCustomerLogins
  );
  const { loggedInCustomerLoginsInfo } = GetLoggedInCustomerLogins;

  const GetAllCountry = useSelector((state) => state.GetAllCountry);
  const { countryInfo } = GetAllCountry;

  const UpdateCustomerProfile = useSelector(
    (state) => state.UpdateCustomerProfile
  );
  const { updateCustomerProfileError, updateCustomerProfileInfo } =
    UpdateCustomerProfile;

  const ChangePasswordFromProfile = useSelector(
    (state) => state.ChangePasswordFromProfile
  );

  const {
    changePasswordFromProfileError,
    changePasswordFromProfileInfo,
    loading: changePasswordFromProfileLoading,
  } = ChangePasswordFromProfile;

  const GetLoggedInCustomerUser = useSelector(
    (state) => state.GetLoggedInCustomerUser
  );
  const { loggedInCustomerUserInfo } = GetLoggedInCustomerUser;

  const UpdateCustomerUserProfile = useSelector(
    (state) => state.UpdateCustomerUserProfile
  );
  const { updateCustomerUserProfileError, updateCustomerUserProfileInfo } =
    UpdateCustomerUserProfile;

  const GetCustomerUserLogos = useSelector(
    (state) => state.GetCustomerUserLogos
  );
  const { customerUserLogosInfo } = GetCustomerUserLogos;

  const DeleteCustomerUserLogo = useSelector(
    (state) => state.DeleteCustomerUserLogo
  );
  const { deleteCustomerUserLogoInfo, deleteCustomerUserLogoError } =
    DeleteCustomerUserLogo;

  const GetChildCustomerByParentId = useSelector(
    (state) => state.GetChildCustomerByParentId
  );
  const { childCustomerInfo } = GetChildCustomerByParentId;

  const GetCustomerLoginsById = useSelector(
    (state) => state.GetCustomerLoginsById
  );
  const { customerLoginsInfo } = GetCustomerLoginsById;

  const GetCustomerLogos = useSelector((state) => state.GetCustomerLogos);
  const { customerLogosInfo } = GetCustomerLogos;

  const DeleteCustomerLogo = useSelector((state) => state.DeleteCustomerLogo);
  const { deleteCustomerLogoInfo, deleteCustomerLogoError } =
    DeleteCustomerLogo;

  const token = JSON.parse(localStorage.getItem("userInfo"));
  const customer_id = JSON.parse(localStorage.getItem("customer_id"));
  const cust_login_id = JSON.parse(localStorage.getItem("customer_login_id"));
  const customer_user_id = JSON.parse(localStorage.getItem("customer_user_id"));
  const DEFAULT_ITINERARY = {
    colors: { Black: true, Blue: false, Red: false, Yellow: false, Cyan: false, Magenta: false },
    section1: { passengerType: false, passengerName: false, loyaltyProgram: false, disabilities: false, ticketNumber: false },
    section2: { agencyName: false, agencyNumber: false, agencyReference: false, checkinReference: false },
    section3: {
      airlineName: false, departure: true, departureTime: false, arrival: false, arrivalTime: false,
      aircraft: false, stop: false, duration: false, terminal: false, operatedBy: false,
      status: false, cabin: false, bookingClass: false,inFlightServices: false
    },
    section4: { paxName: false, origin: false, seat: false, baggage: false, meal: false, wheelchair: false },
    section5: {
      baggageAllowance: { passengerType: false, origin: false, baggage: false, information: false },
      carryonAllowance: { origin: false, baggage: false, information: false }
    }
  };
  const [itinerary, setItinerary] = useState(DEFAULT_ITINERARY);

  useEffect(() => {
    setLogos([]);
    setAdditionalLogos([]);
  }, []);

  useEffect(() => {
    if (token) {
      if (customer_id || cust_login_id) {
        dispatch(getChildCustomerByParentId(customer_id));
        dispatch(getLoggedInCustomer(customer_id));
        dispatch(getLoggedInCustomerLogins(cust_login_id));
        dispatch(getAllCountry());
        dispatch(getCustomerLogos(cust_login_id));
      }
      if (customer_user_id) {
        dispatch(getLoggedInCustomerUser(customer_user_id));
        dispatch(getCustomerUserLogos(customer_user_id));
      }
    }
  }, [token]);

  useEffect(() => {
    if (countryInfo) {
      setCountries(countryInfo);
    }
  }, [countryInfo]);

  useEffect(() => {
    if (updateCustomerProfileInfo) {
      setNotificationOpen(true);
    }
  }, [updateCustomerProfileInfo]);

  useEffect(() => {
    if (updateCustomerProfileError) {
      setErrorAlertTitle("Update Profile Error");
      setErrorAlertMessage(updateCustomerProfileError);
      setErrorAlert(true);
    }
  }, [updateCustomerProfileError]);

  useEffect(() => {
    if (updateCustomerUserProfileInfo) {
      setNotificationOpen(true);
    }
  }, [updateCustomerUserProfileInfo]);

  useEffect(() => {
    if (updateCustomerUserProfileError) {
      setErrorAlertTitle("Update Profile Error");
      setErrorAlertMessage(updateCustomerUserProfileError);
      setErrorAlert(true);
    }
  }, [updateCustomerUserProfileError]);

  useEffect(() => {
    if (changePasswordFromProfileInfo) {
      setNotificationOpen(true);
      setTimeout(() => {
        setCurrent_password("");
        setNew_password("");
        setConfirm_password("");
      }, 3000);

      setTimeout(() => {
        setOpenDialog(false);
        dispatch(logout());
        navigate("/");
      }, 6000);
    }
  }, [changePasswordFromProfileInfo]);

  useEffect(() => {
    if (changePasswordFromProfileError) {
      setErrorAlertTitle("Change Password Error");
      setErrorAlertMessage(changePasswordFromProfileError);
      setErrorAlert(true);
    }
  }, [changePasswordFromProfileError]);

  useEffect(() => {
    if (changePasswordFromProfileLoading) {
      setOpenLoader(true);
    } else {
      setOpenLoader(false);
    }
  }, [changePasswordFromProfileLoading]);

  useEffect(() => {
    if (deleteCustomerUserLogoError) {
      setErrorAlertTitle("Logo Deletion Error");
      setErrorAlertMessage(deleteCustomerUserLogoError);
      setErrorAlert(true);
    }
  }, [deleteCustomerUserLogoError]);

  useEffect(() => {
    if (deleteCustomerLogoError) {
      setErrorAlertTitle("Logo Deletion Error");
      setErrorAlertMessage(deleteCustomerLogoError);
      setErrorAlert(true);
    }
  }, [deleteCustomerLogoError]);

  useEffect(() => {
    if ((loggedInCustomerInfo, loggedInCustomerLoginsInfo)) {
      setCustomer_name(loggedInCustomerInfo?.customer_name?.trim() || "");
      setUsername(loggedInCustomerLoginsInfo?.username?.trim() || "");
      setEmail(loggedInCustomerInfo?.email?.trim()?.split(" ") || []);
      setCC(loggedInCustomerInfo?.cc?.trim()?.split(" ") || []);
      setContact_number(loggedInCustomerInfo?.telephone_number?.trim() || "");
      setPCCs(loggedInCustomerInfo?.pccs?.trim() || "");
      setAddress1(loggedInCustomerInfo?.address_1?.trim() || "");
      setAddress2(loggedInCustomerInfo?.address_2?.trim() || "");
      setCity(loggedInCustomerInfo?.city?.trim() || "");
      setPostal_code(loggedInCustomerInfo?.postal_code?.trim() || "");
      setCountry(loggedInCustomerInfo?.country?.trim() || "");
      setLanguage(loggedInCustomerInfo?.language?.trim() || "");
      setSelectedAdditionalHeaderLogo(
        loggedInCustomerLoginsInfo?.header
          ?.trim()
          ?.split(" ")
          ?.map((id) => parseInt(id, 10)) || []
      );
      setSelectedAdditionalFooterLogo(
        loggedInCustomerLoginsInfo?.footer
          ?.trim()
          ?.split(" ")
          ?.map((id) => parseInt(id, 10)) || []
      );
      setItinerary(loggedInCustomerLoginsInfo?.itinerary_settings || DEFAULT_ITINERARY);
    }
  }, [loggedInCustomerInfo, loggedInCustomerLoginsInfo]);

  useEffect(() => {
    if (loggedInCustomerUserInfo) {
      dispatch(getCustomerLoginsById(loggedInCustomerUserInfo?.created_by));
      setFirst_name(loggedInCustomerUserInfo?.first_name?.trim() || "");
      setLast_name(loggedInCustomerUserInfo?.last_name?.trim() || "");
      setCust_user_username(loggedInCustomerUserInfo?.username?.trim() || "");
      setCust_user_email(loggedInCustomerUserInfo?.email?.trim() || "");
      setCust_user_contact_number(
        loggedInCustomerUserInfo?.contact_number?.trim() || ""
      );
      setCust_user_pcc(loggedInCustomerUserInfo?.pccs?.trim() || "");

      setSelectedHeaderLogo(
        loggedInCustomerUserInfo?.header
          ?.trim()
          ?.split(" ")
          ?.map((id) => parseInt(id, 10)) || []
      );
      setSelectedFooterLogo(
        loggedInCustomerUserInfo?.footer
          ?.trim()
          ?.split(" ")
          ?.map((id) => parseInt(id, 10)) || []
      );
      setItinerary(loggedInCustomerUserInfo?.itinerary_settings || DEFAULT_ITINERARY);
    }
  }, [loggedInCustomerUserInfo]);

  useEffect(() => {
    if (customerLoginsInfo && decodedToken?.role === "customer_user") {
      dispatch(getChildCustomerByParentId(customerLoginsInfo?.customer_id));
    }
  }, [customerLoginsInfo]);

  useEffect(() => {
    if (customerUserLogosInfo) {
      const updatedLogos = customerUserLogosInfo.map((logo) => ({
        id: logo.logo_id,
        name: logo?.name?.trim(),
        logo: logo.logo,
      }));
      setLogos(updatedLogos);
    }
  }, [customerUserLogosInfo]);

  useEffect(() => {
    if (customerLogosInfo) {
      const updatedAdditionalLogos = customerLogosInfo.map((logo) => ({
        id: logo.logo_id,
        name: logo?.name?.trim(),
        logo: logo.logo,
      }));
      setAdditionalLogos(updatedAdditionalLogos);
    }
  }, [customerLogosInfo]);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleProfileClick = () => {
    if (customer_id || cust_login_id) {
      dispatch(getLoggedInCustomer(customer_id));
      dispatch(getLoggedInCustomerLogins(cust_login_id));
      dispatch(getChildCustomerByParentId(customer_id));
      dispatch(getAllCountry());
    }
    if (customer_user_id) {
      dispatch(getLoggedInCustomerUser(customer_user_id));
      dispatch(getCustomerUserLogos(customer_user_id));
    }
    setOpenDialog(true);
    handleMenuClose();
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setLogoError("");
    setAdditionalLogoError("");
    if (customer_id || cust_login_id) {
      dispatch(getLoggedInCustomer(customer_id));
      dispatch(getLoggedInCustomerLogins(cust_login_id));
      dispatch(getChildCustomerByParentId(customer_id));
    }
    if (customer_user_id) {
      dispatch(getLoggedInCustomerUser(customer_user_id));
      dispatch(getCustomerUserLogos(customer_user_id));
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleClickShowOldPassword = () => {
    setShowOldPassword(!showOldPassword);
  };

  const handleClickShowNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  };

  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const generatePassword = () => {
    const length = 12; // Desired password length
    const charset =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let newPassword = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      newPassword += charset[randomIndex];
    }
    setNew_password(newPassword);
  };

  const validateContactNumber = (number) => {
    // Validation: Allow numbers with or without + and country code
    // Option 1: + followed by 10-15 digits
    // Option 2: 10-15 digits
    const regex = /^(?:\+\d{1,3})?\d{10,15}$/;
    return regex.test(number);
  };

  const handleContactNumber = (e) => {
    const number = e.target.value;

    // Allow only valid characters: digits and +
    if (/^[+\d]*$/.test(number)) {
      setContact_number(number);

      if (number && !validateContactNumber(number)) {
        setContact_number_error(
          "Telephone number should be 10-15 digits, with or without a leading + and country code."
        );
      } else {
        setContact_number_error("");
      }
    }
  };

  const handleCustUserContactNumber = (e) => {
    const number = e.target.value; // Allow only valid characters: digits and +
    if (/^[+\d]*$/.test(number)) {
      setCust_user_contact_number(number);

      if (number && !validateContactNumber(number)) {
        setCust_user_contact_number_error(
          "Telephone number should be 10-15 digits, with or without a leading + and country code."
        );
      } else {
        setCust_user_contact_number_error("");
      }
    }
  };

  const validateEmail = (email) => {
    // Basic email validation regex
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleEmail = (event, index) => {
    const enteredEmail = event.target.value.trim();

    if (enteredEmail && !validateEmail(enteredEmail)) {
      setEmailError((prevErrors) => {
        const newErrors = [...prevErrors];
        newErrors[index] = "Invalid email address";
        return newErrors;
      });
    } else {
      setEmailError((prevErrors) => {
        const newErrors = [...prevErrors];
        newErrors[index] = undefined;
        return newErrors;
      });
    }

    const updatedEmails = [...email];
    updatedEmails[index] = enteredEmail;
    setEmail(updatedEmails);
  };

  const handleCustUserEmail = (event) => {
    const enteredEmail = event.target.value.trim();

    if (enteredEmail && !validateEmail(enteredEmail)) {
      setCust_user_email_error("Invalid email address");
    } else {
      setCust_user_email_error("");
    }
    setCust_user_email(enteredEmail);
  };

  const validatePostalCode = (code) => {
    // Example validation: Postal code should be 5 digits long
    const regex = /^[a-zA-Z0-9]{5,10}$/;
    return regex.test(code);
  };

  const handlePostalCodeChange = (e) => {
    const code = e.target.value;

    // Allow only numeric input
    if (/^[a-zA-Z0-9]*$/.test(code)) {
      setPostal_code(code);

      // Validate the postal code
      if (code && !validatePostalCode(code)) {
        setPostalCodeError(
          "The postal code must consist of between 5 and 10 digits."
        );
      } else {
        setPostalCodeError("");
      }
    }
  };

  const handleCC = (event, index) => {
    const enteredCC = event.target.value.trim();

    if (enteredCC && !validateEmail(enteredCC)) {
      setCCError((prevErrors) => {
        const newErrors = [...prevErrors];
        newErrors[index] = "Invalid email address";
        return newErrors;
      });
    } else {
      setCCError((prevErrors) => {
        const newErrors = [...prevErrors];
        newErrors[index] = "";
        return newErrors;
      });
    }
    const updatedCC = [...cc];
    updatedCC[index] = enteredCC;
    setCC(updatedCC);
  };

  const handleImageClick = () => {
    setImageDialogOpen(true);
  };

  const handleImageDialogClose = () => {
    setImageDialogOpen(false);
  };

  const validateImageDimensions = (file, callback, setError) => {
    if (!file || !(file instanceof Blob)) {
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const image = new Image();
      image.src = reader.result;
      image.onload = () => {
        if (image.width > 1300 || image.height > 400) {
          setError("Image dimensions should not exceed 1300x400 pixels.");
        } else {
          setError(""); // Clear error
          callback(reader.result);
        }
      };
    };
    reader.readAsDataURL(file);
  };

  const handleLogoUpload = (file) => {
    validateImageDimensions(
      file,
      (result) => {
        setLogos((prevLogos) => [
          ...prevLogos,
          {
            id: Date.now(), // Using current timestamp as a unique ID for temporary logo identification
            name: "",
            logo: result.replace(/^data:image\/[a-z]+;base64,/, ""),
          },
        ]);
      },
      setLogoError
    );
  };

  const handleAdditionalLogoUpload = (file) => {
    validateImageDimensions(
      file,
      (result) => {
        setAdditionalLogos((prevLogos) => [
          ...prevLogos,
          {
            id: Date.now(),
            name: "",
            logo: result.replace(/^data:image\/[a-z]+;base64,/, ""),
          },
        ]);
      },
      setAdditionalLogoError
    );
  };

  const handleLogoChange = (index, field, value) => {
    const updatedLogos = [...logos];
    updatedLogos[index][field] = value;
    setLogos(updatedLogos);
  };

  const handleAdditionalLogoChange = (index, field, value) => {
    const updatedLogos = [...additionalLogos];
    updatedLogos[index][field] = value;
    setAdditionalLogos(updatedLogos);
  };

  const handleRemoveLogo = (index) => {
    const updatedLogos = [...logos];
    if (String(updatedLogos[index].id).length === 13) {
      // Check if the ID is a timestamp (13 digits)
      updatedLogos.splice(index, 1);
      setLogos(updatedLogos);
    } else {
      dispatch(deleteCustomerUserLogo(updatedLogos[index].id));
      dispatch(getCustomerUserLogos(customer_user_id));
      dispatch(getLoggedInCustomerUser(customer_user_id));
    }
  };

  const handleRemoveAdditionalLogo = (index) => {
    const updatedLogos = [...additionalLogos];
    if (String(updatedLogos[index].id).length === 13) {
      // Check if the ID is a timestamp (13 digits)
      updatedLogos.splice(index, 1);
      setAdditionalLogos(updatedLogos);
    } else {
      dispatch(deleteCustomerLogo(updatedLogos[index].id));
      dispatch(getLoggedInCustomer(customer_id));
      dispatch(getLoggedInCustomerLogins(cust_login_id));
      dispatch(getCustomerLogos(cust_login_id));
    }
  };

  const handlePreviewClick = (image) => {
    setPreviewImage(image);
    setPreviewDialogOpen(true);
  };

  const handlePreviewDialogClose = () => {
    setPreviewImage(null);
    setPreviewDialogOpen(false);
  };

  const handleHeaderSelection = (logoId) => {
    setSelectedHeaderLogo((prevHeaders) => {
      if (prevHeaders.includes(logoId)) {
        return prevHeaders.filter((id) => id !== logoId); // Remove if already selected
      }
      return [...prevHeaders, logoId]; // Add if not selected
    });
  };

  const handleAdditionalHeaderSelection = (logoId) => {
    setSelectedAdditionalHeaderLogo((prevHeaders) => {
      if (prevHeaders.includes(logoId)) {
        return prevHeaders.filter((id) => id !== logoId); // Remove if already selected
      }
      return [...prevHeaders, logoId]; // Add if not selected
    });
  };

  const handleFooterSelection = (logoId) => {
    setSelectedFooterLogo((prevFooters) => {
      if (prevFooters.includes(logoId)) {
        return prevFooters.filter((id) => id !== logoId); // Remove if already selected
      }
      return [...prevFooters, logoId]; // Add if not selected
    });
  };

  const handleAdditionalFooterSelection = (logoId) => {
    setSelectedAdditionalFooterLogo((prevFooters) => {
      if (prevFooters.includes(logoId)) {
        return prevFooters.filter((id) => id !== logoId); // Remove if already selected
      }
      return [...prevFooters, logoId]; // Add if not selected
    });
  };

  const handleSave = () => {
    if (tabValue === 0 && decodedToken?.role === "customer_user") {
      if (cust_user_email_error || cust_user_contact_number_error) {
        setErrorAlertTitle("Invalid values in the field.");
        setErrorAlertMessage(
          "Please ensure the email and contact number fields are valid."
        );
        setErrorAlert(true);
        return;
      }

      if (
        logoError ||
        logos.some(
          (logo) =>
            !logo.name ||
            (!selectedHeaderLogo.includes(logo.id) &&
              !selectedFooterLogo.includes(logo.id))
        )
      ) {
        setErrorAlertTitle("Invalid values in the field.");
        setErrorAlertMessage(
          "Please ensure all logos have a name and are assigned to either header or footer."
        );
        setErrorAlert(true);
        return;
      }

      if (first_name && last_name && cust_user_username && cust_user_email) {
        const customerUser = {
          first_name: first_name?.trim(),
          last_name: last_name?.trim(),
          username: cust_user_username?.trim(),
          email: cust_user_email?.trim(),
          contact_number: cust_user_contact_number?.trim(),
          pccs: cust_user_pcc?.trim(),
          header: selectedHeaderLogo.join(" "),
          footer: selectedFooterLogo.join(" "),
          default_header: loggedInCustomerUserInfo?.default_header,
          default_footer: loggedInCustomerUserInfo?.default_footer,
          role: "customer_user",
          logos: logos,
        };
        dispatch(updateCustomerUserProfile(customer_user_id, customerUser));
      } else {
        setErrorAlertTitle("Required field error");
        setErrorAlertMessage("Please enter the required (*) fields.");
        setErrorAlert(true);
      }
    }
     if (tabValue === 2 && decodedToken?.role === "customer_user") {
      const usernameTemp = cust_user_username?.trim() || "";
      if (usernameTemp && itinerary) {
        const customerUser = {
          // customer_name: customer_name?.trim(),
          username: usernameTemp?.trim(),
          itinerary_settings: itinerary,
        };
        dispatch(updateCustomerUserItinerary(customer_user_id, customerUser));
      } else {
        setErrorAlertTitle("Required field error11");
        setErrorAlertMessage("Please enter the required (*) fields.");
        setErrorAlert(true);
      }
    }
    if (tabValue === 0 && decodedToken?.role === "customer") {
      if (
        emailError.some((error) => error !== undefined) ||
        postalCodeError ||
        contact_number_error
      ) {
        setErrorAlertTitle("Invalid values in the field.");
        setErrorAlertMessage("Please enter the fields properly.");
        setErrorAlert(true);
        return;
      }

      if (username && customer_name && email && PCCs && language && country) {
        const customer = {
          // customer_name: customer_name?.trim(),
          username: username?.trim(),
          // email: email?.join(" ")?.trim(),
          // cc: cc?.join(" ")?.trim() || "",
          // pccs: PCCs?.trim(),
          // language: language,
          // address_1: address1,
          // address_2: address2,
          // city: city,
          // postal_code: postal_code,
          // country: country,
          // telephone_number: contact_number,
          header: selectedAdditionalHeaderLogo.join(" "),
          footer: selectedAdditionalFooterLogo.join(" "),
          default_header: loggedInCustomerInfo?.default_header,
          default_footer: loggedInCustomerInfo?.default_footer,
          logos: additionalLogos,
        };
        dispatch(updateCustomerProfile(cust_login_id, customer));
      } else {
        setErrorAlertTitle("Required field error");
        setErrorAlertMessage("Please enter the required (*) fields.");
        setErrorAlert(true);
      }
    }
    if (tabValue === 1) {
      if (current_passoword && new_password && confirm_password) {
        if (new_password !== confirm_password) {
          setErrorAlertTitle("Password Mismatch");
          setErrorAlertMessage(
            "New password and confirm password should match."
          );
          setErrorAlert(true);
          return;
        }
        const password = {
          current_password: current_passoword,
          new_password: new_password,
          userType: decodedToken?.role,
        };
        if (decodedToken?.role === "customer") {
          dispatch(changePasswordFromProfile(cust_login_id, password));
        }
        if (decodedToken?.role === "customer_user") {
          dispatch(changePasswordFromProfile(customer_user_id, password));
        }
      } else {
        setErrorAlertTitle("Required field error");
        setErrorAlertMessage("Please enter the required (*) fields.");
        setErrorAlert(true);
      }
    }
    if (tabValue === 2 && decodedToken?.role === "customer") {
      const usernameTemp = loggedInCustomerLoginsInfo?.username?.trim() || "";
      if (usernameTemp && itinerary) {
        const customer = {
          // customer_name: customer_name?.trim(),
          username: usernameTemp?.trim(),
          itinerary_settings: itinerary,
        };
        dispatch(updateCustomerItinerary(cust_login_id, customer));
      } else {
        setErrorAlertTitle("Required field error11");
        setErrorAlertMessage("Please enter the required (*) fields.");
        setErrorAlert(true);
      }
    }
  };

  const addEmailField = () => {
    setEmail([...email, ""]);
  };

  const removeEmailField = (index) => {
    const updatedEmails = [...email];
    updatedEmails.splice(index, 1);
    setEmail(updatedEmails);
  };

  const addCCField = () => {
    setCC([...cc, ""]);
  };

  const removeCCField = (index) => {
    const updatedCC = [...cc];
    updatedCC.splice(index, 1);
    setCC(updatedCC);
  };

  const handlePCCs = (event) => {
    const enteredValues = event.target.value
      .split("\n")
      .map((value) => value?.trim());
    const pccs = enteredValues.join(" ");
    setPCCs(pccs);
  };

  const handleCustUserPccs = (event) => {
    const enteredValues = event.target.value
      .split("\n")
      .map((value) => value?.trim());
    const pccs = enteredValues.join(" ");
    setCust_user_pcc(pccs);
  };

  return (
    <>
      <AppBar position="static">
        <Toolbar className="headervartop-top">
          <div className="hdr-top-section">
            <div className="logosectionadd">
              {/* Logo Section */}
              <Box sx={{ flexGrow: 1 }}>
                <Link
                  to="/dashboard"
                  style={{ textDecoration: "none", color: "white" }}
                >
                  <img src={logo} alt="Logo" className="logo" />
                </Link>
              </Box>
            </div>

            <div
              className="header-search-admin"
              style={{
                display: "flex",
                justifyContent: "right",
                alignItems: "center",
              }}
            >
              {/* User Info and Dropdown Menu */}
              <Box className="logged-in-user">
                <Typography variant="body1">
                  {loggedInCustomerInfo && loggedInCustomerInfo?.customer_name}
                  {loggedInCustomerUserInfo &&
                    loggedInCustomerUserInfo?.username}
                </Typography>

                <Button color="inherit" onClick={handleMenuOpen}>
                  <AccountCircle fontSize="large" />
                </Button>
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                >
                  <MenuItem onClick={handleProfileClick}>Profile</MenuItem>
                  <MenuItem onClick={() => dispatch(logout())}>Logout</MenuItem>
                </Menu>
              </Box>
            </div>
          </div>
        </Toolbar>

        {/* Dialog for Profile and Change Password */}
        {decodedToken?.role == "customer" && (
          <Dialog
            open={openDialog}
            onClose={handleDialogClose}
            fullWidth
            maxWidth="lg"
          >
            <DialogContent className="paswradcolwrap">
              <Grid container spacing={2}>
                {/* Left Panel - Tabs for Profile and Change Password */}
                <Grid item xs={3}>
                  <Paper sx={{ padding: 2 }}>
                    <Tabs
                      orientation="vertical"
                      value={tabValue}
                      onChange={handleTabChange}
                      aria-label="Profile and Change Password Tabs"
                    >
                      <Tab label="Profile" />
                      <Tab label="Change Password" />
                      <Tab label="Color-Coded Itinerary" />
                    </Tabs>
                  </Paper>
                </Grid>

                {/* Right Panel - Content based on selected tab */}
                <Grid item xs={9}>
                  <Box sx={{ padding: 2 }}>
                    {/* Profile Content */}
                    {tabValue === 0 && (
                      <div>
                        <Typography variant="h6" gutterBottom>
                          Profile Information
                        </Typography>
                        <h4>Default Logo</h4>
                        <div className="container-feld">
                          {loggedInCustomerInfo?.logo && (
                            <div>
                              <BootstrapTooltip title="Click to expand">
                                <img
                                  src={`data:image/png;base64,${loggedInCustomerInfo.logo}`}
                                  alt="Customer Logo"
                                  style={{
                                    width: "auto",
                                    height: "auto",
                                    maxWidth: "400px",
                                    maxHeight: "400px",
                                    cursor: "pointer",
                                  }}
                                  onClick={handleImageClick}
                                />
                              </BootstrapTooltip>
                            </div>
                          )}
                        </div>

                        {/* Logos */}
                        <h4>Manage additional Logos</h4>
                        {additionalLogos.map((logo, index) => (
                          <>
                            <div className="container-feld" key={index}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={selectedAdditionalHeaderLogo.includes(
                                      logo.id
                                    )}
                                    onChange={() =>
                                      handleAdditionalHeaderSelection(logo.id)
                                    }
                                  />
                                }
                                label="Header"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={selectedAdditionalFooterLogo.includes(
                                      logo.id
                                    )}
                                    onChange={() =>
                                      handleAdditionalFooterSelection(logo.id)
                                    }
                                  />
                                }
                                label="Footer"
                              />

                              <TextField
                                className="anusercol"
                                fullWidth
                                label={`Logo Name ${index + 1}`}
                                value={logo.name}
                                error={!logo.name}
                                helperText={
                                  !logo.name ? "Logo name is required" : ""
                                }
                                onChange={(e) =>
                                  handleAdditionalLogoChange(
                                    index,
                                    "name",
                                    e.target.value
                                  )
                                }
                              />

                              {logo.logo && (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Tooltip title="Click to preview">
                                    <PreviewIcon
                                      fontSize="large"
                                      color="primary"
                                      onClick={() =>
                                        handlePreviewClick(logo.logo)
                                      }
                                      style={{ cursor: "pointer" }}
                                    />
                                  </Tooltip>
                                </div>
                              )}
                              <IconButton
                                onClick={() =>
                                  handleRemoveAdditionalLogo(index)
                                }
                                variant="outlined"
                                color="error"
                                style={{ marginTop: "10px" }}
                              >
                                <CloseIcon />
                              </IconButton>
                            </div>
                          </>
                        ))}

                        <Button
                          variant="outlined"
                          component="label"
                          style={{
                            width: "40%",
                            border: "#5D8B57 1px solid",
                            color: "#5D8B57",
                            padding: "10px 20px",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "bold",
                            transition: "background-color 0.3s",
                          }}
                        >
                          Upload Logo
                          <input
                            type="file"
                            accept="image/*"
                            hidden
                            onChange={(e) =>
                              handleAdditionalLogoUpload(e.target.files[0])
                            }
                          />
                        </Button>

                        <div className="container-feld">
                          {additionalLogoError && (
                            <Typography
                              variant="body2"
                              color="error"
                              className="container-feld"
                            >
                              {additionalLogoError}
                            </Typography>
                          )}
                        </div>

                        <h4>Agency Details</h4>
                        <div className="container-feld">
                          {/* Agency Name */}
                          <div className="txtflicol">
                            <PersonOutlineIcon />
                            <TextField
                              disabled
                              className="anusercol"
                              fullWidth
                              label="Agency Name"
                              required
                              value={customer_name}
                              onChange={(e) => setCustomer_name(e.target.value)}
                            />
                          </div>

                          {/* Username */}
                          <div className="txtflicol">
                            <PersonOutlineIcon />
                            <TextField
                              // disabled
                              fullWidth
                              className="anusercol"
                              label="Username"
                              value={username}
                              onChange={(e) => setUsername(e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        {/* PCCs */}
                        <h4>PCCs</h4>
                        <div className="show-child-pccs">
                          <div className="child-field">
                            <div className="child-field-name">
                              <Typography variant="body1">
                                Parent PCCs
                              </Typography>
                            </div>
                            <div className="txtflicol">
                              <TextField
                                disabled
                                className="anusercol"
                                fullWidth
                                multiline
                                rows={4}
                                onChange={handlePCCs}
                                value={PCCs ? PCCs.split(" ").join(" ") : ""}
                                required
                              />
                            </div>
                          </div>
                        </div>
                        {/* Child PCCs */}
                        <h4>Child PCCs</h4>
                        <div className="show-child-pccs">
                          {childCustomerInfo && childCustomerInfo.length > 0 ? (
                            childCustomerInfo.map((child, index) => (
                              <div key={index} className="child-field">
                                <div className="child-field-name">
                                  <Typography variant="body1">
                                    {child.customer_name}
                                  </Typography>
                                </div>
                                <div className="txtflicol">
                                  <TextField
                                    disabled
                                    className="anusercol"
                                    fullWidth
                                    multiline
                                    rows={3}
                                    value={child.pccs
                                      ?.trim()
                                      ?.split(" ")
                                      .join(" ")}
                                    required
                                  />
                                </div>
                              </div>
                            ))
                          ) : (
                            <Typography variant="body2" color="textSecondary">
                              No child PCCs available.
                            </Typography>
                          )}
                        </div>

                        {/* Contact Number */}
                        <h4>Contact Details</h4>
                        <div className="container-feld">
                          <div className="txtflicol">
                            <PersonOutlineIcon />
                            <TextField
                              disabled
                              fullWidth
                              className="anusercol"
                              label="Contact Number"
                              value={contact_number}
                              error={contact_number_error ? true : false}
                              helperText={contact_number_error}
                              onChange={handleContactNumber}
                            />
                          </div>
                        </div>
                        {/* Address Section */}
                        <h4>Address</h4>
                        <div className="container-feld">
                          <div className="txtflicol">
                            <BusinessIcon />
                            <TextField
                              disabled
                              fullWidth
                              className="anusercol"
                              label="Address Line 1"
                              value={address1}
                              onChange={(e) => setAddress1(e.target.value)}
                            />
                          </div>
                          <div className="txtflicol">
                            <BusinessIcon />
                            <TextField
                              disabled
                              fullWidth
                              className="anusercol"
                              label="Address Line 2"
                              value={address2}
                              onChange={(e) => setAddress2(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="container-feld">
                          <div className="txtflicol">
                            <LocationCityIcon />
                            <TextField
                              disabled
                              fullWidth
                              className="anusercol"
                              label="City"
                              value={city}
                              onChange={(e) => setCity(e.target.value)}
                            />
                          </div>
                          <div className="txtflicol">
                            <MarkunreadMailboxIcon />
                            <TextField
                              disabled
                              fullWidth
                              className="anusercol"
                              label="Postal Code"
                              value={postal_code}
                              error={!!postalCodeError}
                              helperText={postalCodeError}
                              onChange={(e) => handlePostalCodeChange(e)}
                            />
                          </div>
                        </div>
                        <div className="container-feld">
                          <div className="slccounrty">
                            <Autocomplete
                              disabled
                              fullWidth
                              options={countries}
                              value={country}
                              onChange={(event, newValue) =>
                                setCountry(newValue)
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Country"
                                  sx={{
                                    "& .MuiOutlinedInput-root": {
                                      "& fieldset": {
                                        border: "none",
                                      },
                                      "&:hover fieldset": {
                                        border: "none",
                                      },
                                    },
                                  }}
                                  required
                                />
                              )}
                            />
                          </div>
                        </div>
                        <div
                          className="container-feld"
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <Typography sx={{ color: "red" }}>
                            For any changes to these details, please contact the
                            support team.
                          </Typography>
                        </div>
                      </div>
                    )}
                    {/* Change Password Section */}
                    {tabValue === 1 && (
                      <div className="container-feld chngfpsderwr">
                        <Typography variant="h6">Change Password</Typography>

                        <div className="txtflicol">
                          <TextField
                            label="Current Password"
                            type={showOldPassword ? "text" : "password"}
                            fullWidth
                            margin="normal"
                            required
                            value={current_passoword}
                            onChange={(e) =>
                              setCurrent_password(e.target.value)
                            }
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={handleClickShowOldPassword}
                                    color="primary"
                                    edge="end"
                                    sx={{ fontSize: 15 }}
                                  >
                                    {showOldPassword ? "Hide" : "Show"}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <Button
                            onClick={generatePassword}
                            sx={{ fontSize: 12 }}
                            size="small"
                          >
                            Generate Password
                          </Button>
                        </div>

                        <div className="txtflicol">
                          <TextField
                            label="New Password"
                            type={showNewPassword ? "text" : "password"}
                            fullWidth
                            margin="normal"
                            required
                            value={new_password}
                            onChange={(e) => setNew_password(e.target.value)}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={handleClickShowNewPassword}
                                    color="primary"
                                    edge="end"
                                    sx={{ fontSize: 15 }}
                                  >
                                    {showNewPassword ? "Hide" : "Show"}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>

                        <div className="txtflicol">
                          <TextField
                            label="Confirm New Password"
                            type={showConfirmPassword ? "text" : "password"}
                            fullWidth
                            margin="normal"
                            required
                            value={confirm_password}
                            onChange={(e) =>
                              setConfirm_password(e.target.value)
                            }
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={handleClickShowConfirmPassword}
                                    color="primary"
                                    edge="end"
                                    sx={{ fontSize: 15 }}
                                  >
                                    {showConfirmPassword ? "Hide" : "Show"}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                      </div>
                    )}
                    {/*Itinerary color coding*/}
                    {tabValue === 2 && (
                      <div className="container-feld chngfpsderwr">
                        <Typography variant="h6">Color-Coded Itinerary</Typography>
                        <ItinerarySettings value={itinerary} onChange={setItinerary} />

                      </div>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </DialogContent>

            <div className="savbtnanc">
              <DialogActions>
                <Button
                  onClick={handleSave}
                  color="primary"
                // disabled={
                //   tabValue === 0 && decodedToken?.role === "customer"
                //     ? true
                //     : false
                // }
                >
                  Save
                </Button>
                <Button onClick={handleDialogClose} color="primary">
                  Close
                </Button>
              </DialogActions>
            </div>
          </Dialog>
        )}

        {decodedToken?.role == "customer_user" && (
          <Dialog
            open={openDialog}
            onClose={handleDialogClose}
            fullWidth
            maxWidth="lg"
          >
            <DialogContent className="paswradcolwrap">
              <Grid container spacing={2}>
                {/* Left Panel - Tabs for Profile and Change Password */}
                <Grid item xs={3}>
                  <Paper sx={{ padding: 2 }}>
                    <Tabs
                      orientation="vertical"
                      value={tabValue}
                      onChange={handleTabChange}
                      aria-label="Profile and Change Password Tabs"
                    >
                      <Tab label="Profile" />
                      <Tab label="Change Password" />
                      <Tab label="Color-Coded Itinerary" />
                    </Tabs>
                  </Paper>
                </Grid>

                {/* Right Panel - Content based on selected tab */}
                <Grid item xs={9}>
                  <Box sx={{ padding: 2 }}>
                    {/* Profile Content */}
                    {tabValue === 0 && (
                      <div>
                        <Typography variant="h6" gutterBottom>
                          Profile Information
                        </Typography>

                        {/* Logos */}
                        <h4>Manage Logos</h4>
                        {logos.map((logo, index) => (
                          <>
                            <div className="container-feld">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={selectedHeaderLogo.includes(
                                      logo.id
                                    )}
                                    onChange={() =>
                                      handleHeaderSelection(logo.id)
                                    }
                                  />
                                }
                                label="Header"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={selectedFooterLogo.includes(
                                      logo.id
                                    )}
                                    onChange={() =>
                                      handleFooterSelection(logo.id)
                                    }
                                  />
                                }
                                label="Footer"
                              />
                              <TextField
                                className="anusercol"
                                fullWidth
                                label={`Logo Name ${index + 1}`}
                                value={logo.name}
                                error={!logo.name}
                                helperText={
                                  !logo.name ? "Logo name is required" : ""
                                }
                                onChange={(e) =>
                                  handleLogoChange(
                                    index,
                                    "name",
                                    e.target.value
                                  )
                                }
                              />

                              {logo.logo && (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Tooltip title="Click to preview">
                                    <PreviewIcon
                                      fontSize="large"
                                      color="primary"
                                      onClick={() =>
                                        handlePreviewClick(logo.logo)
                                      }
                                      style={{ cursor: "pointer" }}
                                    />
                                  </Tooltip>
                                </div>
                              )}
                              <IconButton
                                onClick={() => handleRemoveLogo(index)}
                                variant="outlined"
                                color="error"
                                style={{ marginTop: "10px" }}
                              >
                                <CloseIcon />
                              </IconButton>
                            </div>
                          </>
                        ))}

                        <Button
                          variant="outlined"
                          component="label"
                          style={{
                            width: "40%",
                            border: "#5D8B57 1px solid",
                            color: "#5D8B57",
                            padding: "10px 20px",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "bold",
                            transition: "background-color 0.3s",
                          }}
                        >
                          Upload Logo
                          <input
                            type="file"
                            accept="image/*"
                            hidden
                            onChange={(e) =>
                              handleLogoUpload(e.target.files[0])
                            }
                          />
                        </Button>
                        <div className="container-feld">
                          {logoError && (
                            <Typography
                              variant="body2"
                              color="error"
                              className="container-feld"
                            >
                              {logoError}
                            </Typography>
                          )}
                        </div>

                        <h4>User Details</h4>
                        <div className="container-feld">
                          {/* First Name */}
                          <div className="txtflicol">
                            <PersonOutlineIcon />
                            <TextField
                              className="anusercol"
                              fullWidth
                              label="First Name"
                              required
                              value={first_name}
                              onChange={(e) => setFirst_name(e.target.value)}
                            />
                          </div>

                          {/* Last Name */}
                          <div className="txtflicol">
                            <PersonOutlineIcon />
                            <TextField
                              fullWidth
                              className="anusercol"
                              label="Last Name"
                              value={last_name}
                              onChange={(e) => setLast_name(e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        <div className="container-feld">
                          {/* Username */}
                          <div className="txtflicol">
                            <PersonOutlineIcon />
                            <TextField
                              className="anusercol"
                              fullWidth
                              label="Username"
                              required
                              value={cust_user_username}
                              onChange={(e) =>
                                setCust_user_username(e.target.value)
                              }
                            />
                          </div>

                          {/* Email */}
                          <div className="txtflicol">
                            <EmailIcon />
                            <TextField
                              fullWidth
                              className="anusercol"
                              label="Email"
                              value={cust_user_email}
                              error={cust_user_email_error ? true : false}
                              helperText={cust_user_email_error}
                              onChange={handleCustUserEmail}
                              required
                            />
                          </div>
                        </div>

                        {/* Conatct Number */}
                        <h4>Contact Details</h4>
                        <div className="container-feld">
                          <div className="txtflicol">
                            <PersonOutlineIcon />
                            <TextField
                              fullWidth
                              className="anusercol"
                              label="Contact Number"
                              value={cust_user_contact_number}
                              error={
                                cust_user_contact_number_error ? true : false
                              }
                              helperText={cust_user_contact_number_error}
                              onChange={handleCustUserContactNumber}
                            />
                          </div>
                        </div>
                        <h4>PCCs</h4>
                        <div className="show-child-pccs">
                          {childCustomerInfo && childCustomerInfo.length > 0 ? (
                            <>
                              {/* Default Customer PCCs */}
                              <div className="child-field">
                                <div className="child-field-name">
                                  <Typography variant="body1">
                                    Default
                                  </Typography>
                                </div>
                                <div className="txtflicol">
                                  <TextField
                                    disabled
                                    className="anusercol"
                                    fullWidth
                                    multiline
                                    rows={3}
                                    value={
                                      cust_user_pcc
                                        ?.split(" ")
                                        .filter(
                                          (pcc) =>
                                            !childCustomerInfo.some((child) =>
                                              child.pccs
                                                ?.split(" ")
                                                .includes(pcc)
                                            )
                                        )
                                        .join(" ") || "No default PCCs"
                                    }
                                    required
                                  />
                                </div>
                              </div>
                              {childCustomerInfo
                                .filter((child) =>
                                  cust_user_pcc
                                    ?.split(" ")
                                    .some((pcc) =>
                                      child.pccs?.split(" ").includes(pcc)
                                    )
                                )
                                .map((child, index) => (
                                  <div key={index} className="child-field">
                                    <div className="child-field-name">
                                      <Typography variant="body1">
                                        {child.customer_name}
                                      </Typography>
                                    </div>
                                    <div className="txtflicol">
                                      <TextField
                                        disabled
                                        className="anusercol"
                                        fullWidth
                                        multiline
                                        rows={3}
                                        value={child.pccs
                                          ?.trim()
                                          ?.split(" ")
                                          .filter((pcc) =>
                                            cust_user_pcc
                                              ?.split(" ")
                                              .includes(pcc)
                                          )
                                          .join(" ")}
                                        required
                                      />
                                    </div>
                                  </div>
                                ))}
                            </>
                          ) : (
                            <div className="child-field">
                              <div className="child-field-name">
                                <Typography variant="body1">Default</Typography>
                              </div>
                              <div className="txtflicol">
                                <TextField
                                  disabled
                                  className="anusercol"
                                  fullWidth
                                  multiline
                                  rows={3}
                                  value={
                                    cust_user_pcc?.split(" ").join(" ") ||
                                    "No default PCCs"
                                  }
                                  required
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    {tabValue === 1 && (
                      <div className="container-feld chngfpsderwr">
                        <Typography variant="h6">Change Password</Typography>
                        <div className="txtflicol">
                          <TextField
                            label="Current Password"
                            type={showOldPassword ? "text" : "password"}
                            fullWidth
                            margin="normal"
                            required
                            value={current_passoword}
                            onChange={(e) =>
                              setCurrent_password(e.target.value)
                            }
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={handleClickShowOldPassword}
                                    color="primary"
                                    edge="end"
                                    sx={{ fontSize: 15 }}
                                  >
                                    {showOldPassword ? "Hide" : "Show"}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <Button
                            onClick={generatePassword}
                            sx={{ fontSize: 12 }}
                            size="small"
                          >
                            Generate Password
                          </Button>
                        </div>

                        <div className="txtflicol">
                          <TextField
                            label="New Password"
                            type={showNewPassword ? "text" : "password"}
                            fullWidth
                            margin="normal"
                            required
                            value={new_password}
                            onChange={(e) => setNew_password(e.target.value)}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={handleClickShowNewPassword}
                                    color="primary"
                                    edge="end"
                                    sx={{ fontSize: 15 }}
                                  >
                                    {showNewPassword ? "Hide" : "Show"}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>

                        <div className="txtflicol">
                          <TextField
                            label="Confirm New Password"
                            type={showConfirmPassword ? "text" : "password"}
                            fullWidth
                            margin="normal"
                            required
                            value={confirm_password}
                            onChange={(e) =>
                              setConfirm_password(e.target.value)
                            }
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={handleClickShowConfirmPassword}
                                    color="primary"
                                    edge="end"
                                    sx={{ fontSize: 15 }}
                                  >
                                    {showConfirmPassword ? "Hide" : "Show"}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </div>
                      </div>
                    )}
                    {/*Itinerary color coding*/}
                    {tabValue === 2 && (
                      <div className="container-feld chngfpsderwr">
                        <Typography variant="h6">Color-Coded Itinerary</Typography>
                        <ItinerarySettings value={itinerary} onChange={setItinerary} />

                      </div>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </DialogContent>
            <div className="savbtnanc">
              <DialogActions>
                <Button onClick={handleSave} color="primary">
                  Save
                </Button>
                <Button onClick={handleDialogClose} color="primary">
                  Close
                </Button>
              </DialogActions>
            </div>
          </Dialog>
        )}

        {/* Dialog for Image Expansion */}
        <Dialog
          open={imageDialogOpen}
          onClose={handleImageDialogClose}
          maxWidth="lg"
        >
          <DialogContent>
            <img
              src={`data:image/png;base64,${loggedInCustomerInfo?.logo}`}
              alt="Customer Logo"
              style={{ width: "100%", height: "auto" }}
            />
          </DialogContent>
          <DialogContent>
            <Typography variant="body1" sx={{ color: "red" }}>
              Note: To change logo contact team.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleImageDialogClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog for Image Preview */}
        <Dialog
          open={previewDialogOpen}
          onClose={handlePreviewDialogClose}
          maxWidth="lg"
        >
          <DialogContent>
            <img
              src={`data:image/png;base64,${previewImage}`}
              alt="Preview"
              style={{ width: "100%", height: "auto" }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handlePreviewDialogClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </AppBar>
      {errorAlert && (
        <NotificationPopup
          open={errorAlert}
          title={errorAlertTitle}
          message={errorAlertMessage}
          onClose={() => {
            setErrorAlert(false);
            dispatch({ type: UPDATE_CUSTOMER_PROFILE_RESET });
            dispatch({ type: UPDATE_CUSTOMER_USER_PROFILE_RESET });
          }}
          severity={"error"}
        />
      )}
      {notificationOpen && updateCustomerProfileInfo && (
        <NotificationPopup
          open={notificationOpen}
          title="Profile Updated"
          message={updateCustomerProfileInfo}
          onClose={() => {
            setNotificationOpen(false);
            dispatch({ type: UPDATE_CUSTOMER_PROFILE_RESET });
          }}
          severity={"success"}
        />
      )}

      {notificationOpen && updateCustomerUserProfileInfo && (
        <NotificationPopup
          open={notificationOpen}
          title="Profile Updated"
          message={updateCustomerUserProfileInfo}
          onClose={() => {
            setNotificationOpen(false);
            dispatch({ type: UPDATE_CUSTOMER_USER_PROFILE_RESET });
          }}
          severity={"success"}
        />
      )}

      {notificationOpen && changePasswordFromProfileInfo && (
        <NotificationPopup
          open={notificationOpen}
          title="Password Changed"
          message={changePasswordFromProfileInfo}
          onClose={() => {
            setNotificationOpen(false);
            dispatch({ type: CHANGE_PASSWORD_FROM_PROFILE_RESET });
          }}
          severity={"success"}
        />
      )}
      {openLoader && <FullPageLoader open={openLoader} />}
    </>
  );
}
